export const mockData = {
  company: {
    name: "AzurDriver Pro",
    slogan: "Votre chauffeur privé premium à Nice et sur la Côte d'Azur",
    phone: "+33 7 67 48 43 67",
    email: "azurdriverpro06@gmail.com",
    whatsapp: "+33767484367",
    availability: "Disponible 7j/7, 24h/24"
  },
  
  hero: {
    title: "AzurDriver Pro",
    subtitle: "Votre chauffeur privé premium à Nice et sur la Côte d'Azur",
    description: "Service de transport haut de gamme avec chauffeur professionnel. Ponctualité, confort et discrétion garantis.",
    cta: "Réserver maintenant"
  },

  services: [
    {
      id: 1,
      title: "Transferts Aéroport",
      description: "Service de transfert depuis et vers l'aéroport Nice Côte d'Azur. Suivi de vol en temps réel, accueil personnalisé.",
      icon: "plane",
      features: ["Suivi de vol", "Accueil personnalisé", "Aide aux bagages"]
    },
    {
      id: 2,
      title: "Transport Business",
      description: "Déplacements professionnels pour vos rendez-vous d'affaires. Ponctualité et discrétion assurées.",
      icon: "briefcase",
      features: ["Ponctualité garantie", "Discrétion absolue", "WiFi à bord"]
    },
    {
      id: 3,
      title: "Mise à Disposition",
      description: "Location avec chauffeur à l'heure ou à la journée selon vos besoins.",
      icon: "clock",
      features: ["Flexibilité totale", "Tarif dégressif", "Service personnalisé"]
    },
    {
      id: 4,
      title: "Tourisme & Événements",
      description: "Découvrez la Côte d'Azur avec votre chauffeur privé. Mariages, soirées, visites touristiques.",
      icon: "palmtree",
      features: ["Circuits personnalisés", "Guide local", "Véhicules premium"]
    }
  ],

  coverage: [
    { city: "Nice", popular: true },
    { city: "Monaco", popular: true },
    { city: "Cannes", popular: true },
    { city: "Antibes", popular: true },
    { city: "Saint-Tropez", popular: true },
    { city: "Menton", popular: true },
    { city: "Juan-les-Pins", popular: true },
    { city: "Grasse", popular: true }
  ],

  whyChooseUs: [
    {
      title: "Ponctualité",
      description: "Nous respectons scrupuleusement vos horaires",
      icon: "clock-check"
    },
    {
      title: "Confort",
      description: "Véhicules premium récents et climatisés",
      icon: "car"
    },
    {
      title: "Discrétion",
      description: "Service confidentiel et professionnel",
      icon: "shield-check"
    },
    {
      title: "Professionnalisme",
      description: "Chauffeurs expérimentés et formés",
      icon: "user-check"
    }
  ],

  pricing: {
    note: "Nos tarifs sont établis sur devis en fonction de votre trajet et de vos besoins spécifiques.",
    features: [
      "Devis gratuit et sans engagement",
      "Tarification transparente",
      "Aucun frais caché",
      "Paiement sécurisé",
      "Facturation disponible pour entreprises"
    ],
    examples: [
      { route: "Aéroport Nice → Monaco", estimation: "Sur devis" },
      { route: "Nice → Cannes", estimation: "Sur devis" },
      { route: "Mise à disposition (4h)", estimation: "Sur devis" },
      { route: "Journée complète (8h)", estimation: "Sur devis" }
    ]
  },

  about: {
    title: "À Propos d'AzurDriver Pro",
    description: "AzurDriver Pro est votre partenaire de confiance pour tous vos déplacements sur la Côte d'Azur. Forts de plusieurs années d'expérience dans le transport de personnes, nous mettons à votre service notre expertise et notre professionnalisme.",
    mission: "Notre mission est de vous offrir un service de transport premium alliant confort, ponctualité et discrétion. Que ce soit pour un transfert aéroport, un déplacement professionnel ou une sortie touristique, nous nous engageons à rendre chaque trajet agréable et sans stress.",
    values: [
      {
        title: "Excellence",
        description: "Nous visons l'excellence dans chaque prestation"
      },
      {
        title: "Fiabilité",
        description: "Une ponctualité et une disponibilité sans faille"
      },
      {
        title: "Confort",
        description: "Des véhicules premium pour votre bien-être"
      }
    ]
  },

  testimonials: [
    {
      id: 1,
      name: "Marie L.",
      rating: 5,
      comment: "Service impeccable ! Chauffeur ponctuel et très professionnel. Je recommande vivement.",
      service: "Transfert Aéroport"
    },
    {
      id: 2,
      name: "Jean-Pierre M.",
      rating: 5,
      comment: "Excellent service pour mes déplacements professionnels. Discrétion et ponctualité au rendez-vous.",
      service: "Transport Business"
    },
    {
      id: 3,
      name: "Sophie D.",
      rating: 5,
      comment: "Une journée magnifique à découvrir la Côte d'Azur avec un chauffeur passionné. Merci !",
      service: "Tourisme"
    }
  ]
};
